import FileSystemClient from './file-system/FileSystemClient.js';
import ServiceClient from './ServiceClient.js';
import AppClient from './AppClient.js';
import FileClient from './file-system/FileClient.js';
import DirectoryClient from './file-system/DirectoryClient.js';
import ShowellClient from './showell/ShowellClient.js';
import AccountClient from './account/AccountClient.js';
import FileConverterClient from './file-system/FileConverterClient.js';
import UserClient from './user/UserClient.js';
import ShareClient from './share/ShareClient.js';
export default class ClientFactory {
    clientOptions;
    clients = {};
    constructor(clientOptions) {
        this.clientOptions = { ...clientOptions };
    }
    setOptions(clientOptions) {
        this.clientOptions = { ...clientOptions };
        this.clients.service?.setOptions(clientOptions);
        this.clients.app?.setOptions(clientOptions);
    }
    getClient(clientName) {
        if (clientName in this.clients && this.clients[clientName]) {
            return this.clients[clientName];
        }
        let client;
        if (clientName === 'service') {
            client = new ServiceClient(this.clientOptions);
        }
        else if (clientName === 'app') {
            client = new AppClient(this.clientOptions);
        }
        else {
            let Client;
            switch (clientName) {
                case 'account':
                    Client = AccountClient;
                    break;
                case 'directory':
                    Client = DirectoryClient;
                    break;
                case 'fileSystem':
                    Client = FileSystemClient;
                    break;
                case 'file':
                    Client = FileClient;
                    break;
                case 'fileConverter':
                    Client = FileConverterClient;
                    break;
                case 'share':
                    Client = ShareClient;
                    break;
                case 'showell':
                    Client = ShowellClient;
                    break;
                case 'user':
                    Client = UserClient;
                    break;
            }
            if (!Client) {
                throw new Error(`'Unknown client: '${clientName}'`);
            }
            const apiClient = this.getClient('service');
            client = new Client(apiClient);
        }
        this.clients[clientName] = client;
        return client;
    }
}
